import { getMeetingSummaryProps } from '../../utils/getMeetingSummaryProps';
import { observer } from 'mobx-react-lite';
import { formatUserDate, userDate } from 'owa-datetime';
import { formatToArray } from 'owa-localize';
import { isMeetingRequest } from 'owa-meeting-message';
import MeetingCancellationMessageType from 'owa-service/lib/contract/MeetingCancellationMessageType';
import MeetingMessage from 'owa-service/lib/contract/MeetingMessage';
import MeetingRequestMessageType from 'owa-service/lib/contract/MeetingRequestMessageType';
import MeetingResponseMessageType from 'owa-service/lib/contract/MeetingResponseMessageType';
import * as React from 'react';

const styles = require('./SenderSummary.scss');

export interface SenderSummaryProps {
    message: MeetingMessage;
    senderPersona: JSX.Element;
}

const SenderSummary = observer(function SenderSummary(props: SenderSummaryProps) {
    const { message, senderPersona } = props;
    const summaryProps = getMeetingSummaryProps(message);

    if (summaryProps) {
        let start: string;
        if (isMeetingRequest(message.ItemClass)) {
            const request = message as MeetingRequestMessageType;
            start = request.OriginalStart || request.Start;
        } else {
            start = (message as MeetingCancellationMessageType | MeetingResponseMessageType).Start;
        }
        return (
            <span className={styles.senderSummary}>
                {formatToArray(
                    summaryProps.senderSummary,
                    senderPersona,
                    <span>{formatUserDate(userDate(start))}</span>
                )}
            </span>
        );
    } else {
        return senderPersona;
    }
});
export default SenderSummary;
